import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '@libs/ui-lib';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { PrescriptionsItemComponent } from '../prescriptions-item/prescriptions-item.component';
import { PrescriptionsTabService } from './prescriptions-tab.service';

@Component({
  selector: 'lib-prescriptions-tab',
  standalone: true,
  imports: [CommonModule, TranslateModule, TooltipModule, PrescriptionsItemComponent, LottieComponent],
  templateUrl: './prescriptions-tab.component.html',
  styleUrl: './prescriptions-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrescriptionsTabComponent {
  private readonly prescriptionsTabService = inject(PrescriptionsTabService);
  protected readonly prescriptionsTabVM = this.prescriptionsTabService.viewModel;

  public readonly lottieOptions: AnimationOptions = {
    path: '/assets/animations/loading-spinner.json',
  };
}
